<div class="container">
    <div class="detail">
        <div class="card" *ngFor="let cat of data" (click)="select(cat)">
            <div class="card-header">
                <div class="card-title" nz-tooltip [nzTooltipTitle]="cat.category_id">{{cat.category_id}}</div>
                <div class="card-subtitle" nz-tooltip [nzTooltipTitle]="cat.category_name">{{cat.category_name}}</div>
            </div>
            <div class="card-content">
                <div *ngIf="cat.attributes != null" class="tags">
                    <ul>
                        <li *ngFor="let item of cat.attributes">
                            {{item.name}}:<b>{{item.value_name}}</b>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
